/*
 jquery.horizontalTimeline
 version 1.0 alpha

 Pedro Santos
 copyright 2012
 */
(function($) {

	var defaults = {
		pos:0
	};

	jQuery.fn.horizontalTimeline = function(options) {

		// method calling
		if (typeof options == 'string') {
			var args = Array.prototype.slice.call(arguments, 1);
			var res;

			this.each(function() {
				var timeline = $.data(this, 'timeline');
				if (timeline && $.isFunction(timeline[options])) {
					var r = timeline[options].apply(timeline, args);
					if (res === undefined) {
						res = r;
					}
					if (options == 'destroy') {
						$.removeData(this, 'timeline');
					}
				}
			});
			if (res !== undefined) {
				return res;
			}
			return this;
		}

		options = $.extend(true, {},
			defaults,
			options
		);


		this.each(function(i, _element) {
			var element = $(_element);
			var timeline = new TimeLine(element, options);
			element.data('timeline', timeline);
			timeline.render();
		});


		return this;
	};

	function TimeLine(element, options) {
		var t = this, e = $(element), o = options;
		var pos = 0;

		// exports
		t.render = render;
		t.getPosition = getPosition;
		t.setPosition = setPosition;

		function render() {
			var container = $('<table style="width: 100%;"></table>');
			var row = $('<tr></tr>'), col;

			var slider = $('<table style="width: 100%;"></table>');

			for(var i = 0; i < 12; i++){
				col = $('<td align="center" valign="middle" style="width: 8.33%; height: 50px; background-color: green;">' + (i+1) + '</td>');

				row.append(col);
			}

			container.append(row);

			e.append(container);

			return this;
		}

		function getPosition() {
			return pos;
		}

		function setPosition(_pos) {
			pos = _pos;

			return this;
		}
	}

})(jQuery);